
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/petitions/[sharecode]",
      function () {
        return require("private-next-pages/petitions/[sharecode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/petitions/[sharecode]"])
      });
    }
  